<div class="detail-container">
  <form [formGroup]="groupDetailForm" #form="ngForm">
    <div class="section container-fluid col-md-11 justify-content-center" fxLayoutGap="grid">
      <div class="innertitletxt">
        Groupe :
      </div>

      <div class="card">
        <div class="card-body">
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="50">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Nom </mat-label>
                  <input matInput formControlName="Name" placeholder="Nom" [ngClass]="{ 'is-invalid': submitted && formControls.Name.errors }" required>
                </mat-form-field>
              </div>
              <div fxFlex="10">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Actif </mat-label>
                  <input matInput hidden readonly>
                  <mat-slide-toggle formControlName="IsActive" tooltip="Activer ou désactiver le groupe" class="customToggle"
                    [disabled]="(groupDetailModel.Id && groupDetailModel.IsActive && !canDisable) || (!groupDetailModel.IsActive && !groupDetailModel.CanBeEnabled)">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
              <div fxFlex="40" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Référent </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="userReferentDropDownSettings" [data]="dataReferentItems" placeholder='Sélectionner...' [(ngModel)]="userReferentSelectedItems"
                    formControlName="Supervisor" ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px">
              <div fxFlex="25" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Type </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="typeDropdownSettings" [data]="typeDropdownListData" [disabled]="isGroupIdDefined" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                    placeholder='Sélectionner...' [(ngModel)]="typeSelectedItems" formControlName="Type" ngDefaultControl>
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="25" *ngIf="isGroupBackupTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Marque </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="marqueDropdownSettings" [data]="marqueDropdownListData" placeholder='Sélectionner...' [(ngModel)]="marqueSelectedItems" formControlName="Marque"
                    ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="20" *ngIf="isGroupBackupTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Typologie </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="typologieDropdownSettings" [data]="typologieDropdownListData" placeholder='Sélectionner...' [(ngModel)]="typologieSelectedItems"
                    formControlName="Typologie" ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="30" *ngIf="isGroupBackupTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Arborescence </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="arboDropdownSettings" [data]="arboDropdownListData" placeholder='Sélectionner...' [(ngModel)]="arboSelectedItems" formControlName="Arborescence"
                    ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="25" *ngIf="isGroupOperationalTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe de contrôle </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="singleSelectionDropdownSettings" [data]="controlGroupsDropdownListData" placeholder='Sélectionner...' formControlName="ControlGroup"
                    [(ngModel)]="controlGroupsSelectedItems" (onFilterChange)="onGroupFilterChange(7, $event)" ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="25" *ngIf="isGroupControlTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe opérationnel </mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="singleSelectionDropdownSettings" [data]="operationalGroupsDropdownListData" placeholder='Sélectionner...' formControlName="ControlGroup"
                    [(ngModel)]="operationalGroupsSelectedItems" (onFilterChange)="onGroupFilterChange(2, $event)" ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="25" *ngIf="isGroupOperationalTypeSelected" class="dropDownStyle">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Métier *</mat-label>
                  <input matInput hidden readonly>
                  <ng-multiselect-dropdown [settings]="professionDropdownSettings" [data]="professionDropdownListData" (onDeSelect)="onItemSelect()" (onSelect)="onItemSelect()"
                    placeholder='Sélectionner...' [(ngModel)]="professionSelectedItems" formControlName="ProfessionType" ngDefaultControl [disabled]="!this.isAdministrator">
                  </ng-multiselect-dropdown>
                </mat-form-field>
              </div>
              <div fxFlex="10" *ngIf="isGroupOperationalTypeSelected">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Facture AGI </mat-label>
                  <input matInput hidden readonly>
                  <mat-slide-toggle formControlName="CanManageInvoiceAGI" tooltip="Ne pas rendre la saisie du fournisseur eValua obligatoire" class="customToggle" [disabled]="!this.isAdministrator">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
              <div fxFlex="15" *ngIf="isGroupOperationalTypeSelected">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Création facture / situation dans PPR </mat-label>
                  <input matInput hidden readonly>
                  <mat-slide-toggle formControlName="CanCreateInPPR" class="customToggle" [tooltip]="formControls.IsVoucher.value
                  ? 'Ne peux être activé lorsque le groupe est flagué BAP Digital'
                  : 'Activer / Désactiver la création de facture/ST dans PPR'" [disabled]="formControls.IsVoucher.value">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
            </div>
            <hr class="separator" *ngIf="isGroupOperationalTypeSelected">
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="isGroupOperationalTypeSelected">
              <div fxFlex="10">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>BAP Digital </mat-label>
                  <input matInput hidden readonly>
                  <mat-slide-toggle [disabled]="groupDetailModel.IsVoucher && !groupDetailModel.CanTurnOffVoucherFlag" formControlName="IsVoucher" tooltip="Activer si le groupe est flagué BAP Digital"
                    class="customToggle">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
              <div fxFlex="10">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Groupe prescripteur</mat-label>
                  <input matInput hidden readonly>
                  <mat-slide-toggle formControlName="IsPrescriptor" [tooltip]="'Est-ce un groupe prescripteur ?'">
                  </mat-slide-toggle>
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="IsVoucher">
              <div fxFlex="33">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Direction </mat-label>
                  <input matInput formControlName="VoucherDepartment" [disabled]="!this.isAdministrator">
                </mat-form-field>
              </div>
              <div fxFlex="33">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Section Analytique </mat-label>
                  <input matInput formControlName="VoucherAnalyticalSection" [disabled]="!this.isAdministrator">
                </mat-form-field>
              </div>
              <div fxFlex="33">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Code Analytique </mat-label>
                  <input matInput formControlName="VoucherAnalyticalCode" [disabled]="!this.isAdministrator">
                </mat-form-field>
              </div>
            </div>
            <div fxLayout="row" fxFlex="100" fxLayoutGap="10px" *ngIf="IsVoucher">
              <div fxFlex="100">
                <mat-form-field floatLabel="always" appearance="outline">
                  <mat-label>Commentaire </mat-label>
                  <textarea matInput formControlName="VoucherComment" matTextareaAutosize matAutosizeMinRows=3 matAutosizeMaxRows=6 [disabled]="!this.isAdministrator">
                  </textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout=”row” fxLayoutAlign="end">
        <button mat-stroked-button class="currentBtnColor" (click)="$event.stopPropagation();exportUsers();" tooltip="Exporter au format excel les utilisateurs du groupe">
          <mat-icon>download</mat-icon>
          <span fxHide fxShow.gt-md>Exporter sur Excel</span>
        </button>
      </div>

      <div class="card">
        <div class="card-header">
          Utilisateurs
        </div>
        <div class="card-body">
          <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
            <div fxLayout="row" fxFlex="100" class="dropDownStyle" *ngIf="this.isAdministrator">
              <mat-form-field floatLabel="always" appearance="outline">
                <mat-label>Ajouter un utilisateur </mat-label>
                <input matInput hidden readonly>
                <ng-multiselect-dropdown (onSelect)="onSelectUser($event,'select')" placeholder='Sélectionner...' (onDeSelect)="onSelectUser($event,'deselect')"
                  (onDeSelectAll)="onSelectUser($event,'deselectall')" (onSelectAll)="onSelectUser($event,'selectall')" [settings]="userDropDownSettings" formControlName="Users"
                  [data]="userDropdownListData" tooltip="Veuillez Sélectionner les utilisateurs à attacher au groupe" [(ngModel)]="userSelectedItems" ngDefaultControl>
                </ng-multiselect-dropdown>
              </mat-form-field>
            </div>
            <div>
              <app-table [data]="dataItems" [tableActions]="tableActions" [configKey]="configKey" [persistFilter]="false" [exportFileName]="exportFileName" [columnsDefinition]="columnsDefinition"
                [onChangeStatus]="onChangeStatus" ngDefaultControl [onExportExcelCaller]="onExportExcelCaller">
              </app-table>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div fxLayout=”row” fxLayoutAlign="end" class="bottom-bar">
      <div fxLayout=”row” fxLayoutAlign="end">
        <div class="btnSpacerCol" *ngIf="isGroupIdDefined && this.isAdministrator">
          <button mat-stroked-button class="currentBtn" matTooltip="Transférer les utilisateurs" (click)="onForward()">
            <mat-icon>group_add</mat-icon>
            <span class="long-btn-span really-large" fxHide fxShow.gt-md>Transférer les utilisateurs</span>
          </button>
        </div>
        <div class="btnSpacerCol">
          <button mat-stroked-button class="currentBtn" matTooltip="Annuler" (click)="onCancel()">
            <mat-icon>cancel</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Annuler</span>
          </button>
        </div>
        <div class="btnSpacerCol" *ngIf="isGroupIdDefined && this.isAdministrator">
          <button mat-stroked-button class="currentBtnColor" [disabled]="groupDetailForm.invalid" matTooltip="Modifier le groupe" (click)="onSubmit()">
            <mat-icon>save</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Modifier</span>
          </button>
        </div>
        <div class="btnSpacerCol" *ngIf="!isGroupIdDefined && this.isAdministrator">
          <button mat-stroked-button class="currentBtnColor" [disabled]="groupDetailForm.invalid" matTooltip="Ajouter le groupe" (click)="onSubmit()">
            <mat-icon>add_circle</mat-icon>
            <span class="long-btn-span" fxHide fxShow.gt-md>Ajouter</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>